<template>
    <section class="gmp-section gmp-mb-l">

        <div class="subpage-hero">
            <div class="two-column-tout">
                <div class="h-c-page">
                    <div class="h-c-grid">
                        <div class="h-c-grid__col h-c-grid__col-xl--offset-1 h-c-grid__col-l--6 h-c-grid__col-xl--5  h-c-grid__col--align-middle
            two-column-tout__content">
                            <h1 class="h-c-headline h-c-headline--display-two h-has-bottom-margin">
                                提高运营效率
                            </h1>
                            <div class="h-u-mb-std two-column-tout__description">
                                <p>
                                    简化订货和库存管理：通过“时鲜管理”小程序，售卖窗口可以更方便地管理库存，自动生成采购订单，确保关键食材不会短缺，同时避免过度库存积压。
                                    实时库存监控：小程序提供实时库存监控功能，售卖窗口能够随时查看库存状态，及时补货，减少因库存不足导致的销售机会损失。
                                </p>
                            </div>

                        </div>

                        <div class="h-c-grid__col  h-c-grid__col-l--6  h-c-grid__col--align-middle">
                            <div class="two-column-tout__image text-center">
                                <picture>
                                    <img src="@/assets/img/win_fast.png" alt="" class="gmp-no-grab ">
                                </picture>
                            </div>
                        </div>

                    </div>
                </div>
            </div>


        </div>

    </section>
</template>

<script>
    export default {
        name: "WIN_subpagehero"
    }
</script>

<style lang="less">


</style>